import "./polyfills";
import {provide, enableProdMode} from "@angular/core";
import {PathLocationStrategy, LocationStrategy} from "@angular/common";
import {ROUTER_PROVIDERS} from "@angular/router-deprecated";
import {wrap} from "./http.util";
import {HTTP_PROVIDERS} from "@angular/http";
import {TRANSLATOR_PROVIDERS} from "../translator/translate.service";
import {isClient} from "./client.util";
import {disableDeprecatedForms, provideForms} from "@angular/forms";

// add redirect-interceptor for all client-side requests
if (isClient()) {
  wrap(require('./redirect.interceptor'));
}

var devMode = require('devMode');
if (!devMode) {
  enableProdMode();
}

export var defaultProviders = [
  disableDeprecatedForms(),
  provideForms(),
  ROUTER_PROVIDERS,
  HTTP_PROVIDERS,
  TRANSLATOR_PROVIDERS,
  provide(LocationStrategy, {useClass: PathLocationStrategy}),
];

export function boot(main:(initialHmrState?:any)=> Promise<any>) {
  if (devMode) {
    let hmr = require('angular2-hmr');
    hmr.hotModuleReplacement(main, module);
  } else {
    main();
  }
}




/** WEBPACK FOOTER **
 ** ./client/app/shared/utils/bootstrap.util.ts
 **/